module.exports = __webpack_public_path__ + "static/media/YunuenGarciaHerrera.c09e2787.png";